module.exports = __webpack_public_path__ + "static/media/ZOOMIN_primary_logotype.0f98ea3c.svg";